import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = 100;

const zoomSlice = createSlice({
  name: "zoomLevel",
  initialState,
  reducers: {
    setZoomLevel: (_state: number, action: PayloadAction<number>) => action.payload,
  },
});

export const { setZoomLevel } = zoomSlice.actions;
export default zoomSlice.reducer;
